import AppConfig from "./app-config";

export const analyticsConfig = {
  search: {
    component_name: "find_installer_dealer_search",
    component_type: "search",
    area_name: "{name}",
  },
  installersTab: {
    component_name: "find_installer_dealer_option_click",
    component_type: "option_click",
    installers: `${AppConfig.installers}_${AppConfig.results}`,
  },
  dealersTab: {
    component_name: "find_installer_dealer_option_click",
    component_type: "option_click",
    installers: `${AppConfig.dealers}_${AppConfig.results}`,
  },
  callInstaller: {
    component_name: "find_installer_dealer_contact_number_clicks",
    component_type: "contact_number_link",
    dealer_installer_name: "{name}",
    dealer_installer_contact_number: "{telephone}"
  },
  directions: {
    component_name: "find_installer_dealer_take_me_there_click",
    component_type: "cta_take_me_there",
    dealer_installer_name: "{name}",
    dealer_installer_address: "{address}",
    target_page_url: "{url}}"
  },
  copyToClipboard: {
    component_name: "find_installer_dealer_contact_number_clipboard",
    component_type: "contact_number_link",
    dealer_installer_name: "{name}",
    dealer_installer_contact_number: "{telephone}"
  }
}

export default analyticsConfig;
